<template>
  <div class="weui-cell weui-cell_select" :class="[cSelectLabel ? 'weui-cell_select-after' : '', themeName]">
    <div class="weui-cell__hd">
      <label class="weui-label">{{title}}</label>
    </div>
    <div class="weui-cell__bd">
      <select class="weui-select"
              dir="rtl"
              :disabled="isDisabled"
              :class="{'text-right' : alignRight}"
              v-if="options.length"
              @change="selectChange">
        <option v-for="option in options"
                :key="option.label"
                :value="option.value"
                :selected="value[comValue] == option[comValue]">
          {{option.label}}
        </option>
      </select>
      <span class="weui-select" v-else>
        {{ content }}
      </span>
    </div>
    <div class="weui-cell__ft">
      <slot name="foot"></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default {
    name: 'c-cell-select',
    props: {
      options: {
        type: Array,
        default () {
          return []
        }
      },
      title: {
        type: String,
        default: ''
      },
      content: {
        type: [String, Number],
        defalut: ''
      },
      point: {
        type: Boolean,
        default: true
      },
      cSelectLabel: {
        type: Boolean,
        default: true
      },
      themeName: {
        type: String,
        default: ''
      },
      value: {
        type: Object,
        default () {
          return {}
        }
      },
      comValue: {
        type: String,
        default: 'value' // ['label', 'value']
      },
      alignRight: {
        type: Boolean,
        default: false
      },
      isDisabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      selectChange (val) {
        let index = val.target.selectedIndex
        let item = this.options[index]
        this.$emit('input', item)
        this.$emit('select', item)
      }
    },
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?2565355c